module.exports = __webpack_public_path__ + "img/EYE.3266084c.svg";